module.exports = __webpack_public_path__ + "static/img/2.f1875bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/2.png
// module id = AHiq
// module chunks = 0